export const AnalysisWholesaler = {
    path: '/analysis/wholesaler',
    name: 'analysis.wholesaler',
    component: () => import('@/views/Analysis/AnalysisWholesaler.vue')
}